// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setAssignment: (state: IRootState, action: PayloadAction<IRootState['assignments']>) => ({
    ...state,
    assignments: action.payload,
  }),
  resetCatalogInfo: () => initialState,
};

export { reducers };
